<template>
    <div id="X15">
        <view1 :selectedProduct="selectedProduct" />
        <carouselView :selectedProduct="selectedProduct" />
        <parameterView :selectedProduct="selectedProduct" />
        <view2 :selectedProduct="selectedProduct" />
        <mapView :selectedProduct="selectedProduct" />
        <tabsView :selectedProduct="selectedProduct" :activeSubTab.sync="activeSubTab" />
        <detailView
          v-for="(item, index) in selectedProduct.detail" 
          :key="index"
          :detailData="item"
        />
        <linkView />
    
    </div>
</template>
<script>
import productData from '@/mixins/productData.js'
export default {
    mixins: [productData],
    name: 'UAVControlPlatform',
    components: {
        view1: () => import('@/views/UAVControlPlatform/view1.vue'),
        carouselView: () => import('@/views/UAVControlPlatform/carousel.vue'),
        
        // 非首屏/重型组件异步加载
        parameterView: () => import('@/views/UAVControlPlatform/parameter.vue'),
        view2: () => import('@/views/UAVControlPlatform/view2.vue'),
        mapView: () => import('@/views/UAVControlPlatform/map.vue'), // 地图组件通常很大，必须异步
        tabsView: () => import('@/views/UAVControlPlatform/tabs.vue'),
        detailView: () => import('@/views/UAVControlPlatform/detail.vue'),
        linkView: () => import('@/views/UAVControlPlatform/link.vue')
    },
    data() {
        return {
            selectedProduct: null,
            activeSubTab: '1',
            activeTab: '1',
            isInitialized: false, // 标记是否已初始化完成
        }
    },
    watch: {
        '$route.query.code': {
            handler(newVal) {
                const code = newVal || '';
                this.activeTab = code;
            },
            immediate: true
        },
        activeTab: {
            handler(newVal) {
                const targetRoute = `/UAVControlPlatform?code=${newVal}`;
                const currentRoute = this.$route.fullPath;
                // 只有当目标路由与当前路由不同时才跳转，避免冗余导航错误
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        // 忽略 NavigationDuplicated 错误（Vue Router 3.x）
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
                const newProduct = this.platformSoftware.find(item => item.code === newVal) || this.platformSoftware[0];
                this.selectedProduct = newProduct;
                // 当切换产品时，重置 activeSubTab 为第一个，但不触发滚动
                if (newProduct && newProduct.detail && newProduct.detail.length > 0) {
                    const firstDetailCode = newProduct.detail[0].code;
                    this.activeSubTab = firstDetailCode;
                }
            },
            immediate: true
        },
        activeSubTab: {
            handler(newVal) {
                // 只有在初始化完成后，用户点击 tab 时才滚动到对应的锚点位置
                if (this.isInitialized) {
                    this.$nextTick(() => {
                        this.scrollToAnchor(newVal);
                    });
                }
            },
            immediate: false
        },
    },
    mounted() {
        // 标记初始化完成，之后 activeSubTab 的改变才会触发滚动
        this.$nextTick(() => {
            this.isInitialized = true;
        });
    },
    methods: {
        scrollToAnchor(code) {
            // 根据 code 找到对应的 detail 元素
            const elementId = `detail-${code}`;
            const element = document.getElementById(elementId);
            
            if (element) {
                // 获取 #app 容器（根据 App.vue，滚动容器是 #app）
                const appContainer = document.getElementById('app');
                if (appContainer) {
                    // 计算目标元素相对于滚动容器的位置
                    const containerRect = appContainer.getBoundingClientRect();
                    const elementRect = element.getBoundingClientRect();
                    const scrollTop = appContainer.scrollTop;
                    const targetScrollTop = scrollTop + elementRect.top - containerRect.top - 100; // 减去 100px 作为偏移量
                    
                    // 平滑滚动到目标位置
                    appContainer.scrollTo({
                        top: targetScrollTop,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }

}
</script>
<style scoped></style>